import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import { getMessage } from '@tcc/i18n';
import Card from '../../../components/cards/cardAndPreview/Card';
import { RegionReportCard } from '../RegionReportCard/RegionReportCard';

// Actions
import { openModal as openModalAction, closeModal } from '../../../actions/modalActions';
import { clearRegionReport } from '../../../actions/regionActions';
import { setSelectedActivity } from '../../../actions/scoutingActions';

// Selectors
import { getRegions } from '../../../selectors/scoutingSelectors';
import { getInversedFieldBoundary } from '../../../selectors/fieldSelectors';

// Utils and Constants
import { getGeoJson } from '../../../utils/geo';
import { getAnalyticsParamsFromActivity } from '../../../utils/analytics';
import { REGION_REPORT } from '../../../constants/modal';
import { trackEvent } from '../../../actions/analyticsActions';
import styles from './RegionsCard.css';
import { ModalType, ModalMode, ModalSize } from '../../../types';

const getRegionsCardContent = (
  activities,
  fieldBoundary,
  locale,
  onRegionClick
) => {
  if (!activities.length) {
    return (
      <div className={styles.emptyRegions} data-test-id="no-regions">
        {getMessage('card.noRegions')}
      </div>
    );
  }

  return activities.map((activity) => {
    const geoJson = getGeoJson([fieldBoundary, activity.location]);
    return (
      <RegionReportCard
        activity={activity}
        geoJson={geoJson}
        key={activity.id}
        locale={locale}
        onRegionClick={onRegionClick}
      />
    );
  });
};

export function RegionsCard({
  fieldBoundary,
  activities,
  locale,
  index,
  openModal,
  trackAnalyticsEvent,
  showPaywall,
}) {
  const onRegionClick = (activity) => {
    trackAnalyticsEvent('region_note', 'opened', {
      regionNoteUuid: activity.id,
      ...getAnalyticsParamsFromActivity(activity),
    });
    if (showPaywall) {
      openModal(index, null, {
        type: ModalType.PAYWALL,
        mode: ModalMode.PAYWALL_REGION_REPORT,
      });
    } else {
      openModal(index, null, {
        type: REGION_REPORT,
        size: ModalSize.L,
        activity,
        mode: ModalMode.EDIT_REGION,
      });
    }
  };

  const regions = getRegionsCardContent(
    activities,
    fieldBoundary,
    locale,
    onRegionClick
  );
  return (
    <div>
      <Card testId="dmb-regions-card" title={getMessage('card.Regions')}>
        {regions}
      </Card>
    </div>
  );
}

RegionsCard.propTypes = {
  activities: PropTypes.array.isRequired,
  fieldBoundary: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired,
  trackAnalyticsEvent: PropTypes.func,
  showPaywall: PropTypes.bool.isRequired,
};

function mapStateToProps(state, props) {
  return {
    activities: getRegions(state, props),
    fieldBoundary: getInversedFieldBoundary(state),
    locale: state.app.locale,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openModal: openModalAction,
      trackAnalyticsEvent: trackEvent,
      clearRegionReport,
      closeModal,
      setSelectedActivity,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegionsCard);
